import { useEffect, useState } from 'react';
import { OnboardingContinueButton } from '@/features/onboarding/components/onboarding-continue-button';
import processingPiggy from '../assets/processing-piggy.webp';
import { PROCESSING_ESTIMATE_AMOUNT } from '../constants';

const COUNT_DURATION_MS = 1200;

interface ProcessingResultsProps {
  onContinue: () => void;
}

function easeOutCubic(t: number): number {
  return 1 - (1 - t) ** 3;
}

export function ProcessingResults({ onContinue }: ProcessingResultsProps) {
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    const start = performance.now();
    let frame = 0;

    const tick = (now: number) => {
      const progress = Math.min(1, (now - start) / COUNT_DURATION_MS);
      setAmount(Math.round(easeOutCubic(progress) * PROCESSING_ESTIMATE_AMOUNT));
      if (progress < 1) {
        frame = requestAnimationFrame(tick);
      }
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <div className="mx-auto flex min-h-[100dvh] w-full max-w-[500px] flex-col bg-mf-neutral-50 px-4 pb-4 font-body">
      <div className="flex min-h-0 flex-1 items-center justify-center pt-2">
        <img
          src={processingPiggy}
          alt=""
          className="h-auto max-h-[min(390px,48dvh)] w-full max-w-[304px] object-contain"
        />
      </div>

      <div className="flex w-full shrink-0 flex-col gap-4 pt-4">
        <div className="w-full text-center">
          <h1 className="font-display text-xl font-bold leading-6 text-mf-neutral-900">
            You could be owed more
            <br />
            than you think
          </h1>
          <p className="mt-0.5 font-display text-[48px] font-extrabold leading-[60px] text-mf-green">
            <span>Up to </span>
            <span>${amount.toLocaleString('en-US')}</span>
            <span>*</span>
          </p>
          <p className="mt-1 text-xs leading-4 text-mf-neutral-400">
            *This is an estimate based on your answers, your approximate location, and currently
            available settlements. It is not a guarantee of payment. Actual results depend on
            eligibility, participation, and settlement outcomes, and may be higher, lower, or zero.
          </p>
        </div>

        <OnboardingContinueButton onClick={onContinue} />
      </div>
    </div>
  );
}
